import { createFileRoute } from "@tanstack/react-router";
import { AccountDeletedPage } from "@/features/auth/components/AccountDeletionPage";

const optionalTime = (value: unknown) =>
  typeof value === "string" && !Number.isNaN(Date.parse(value)) ? value : undefined;

export const Route = createFileRoute("/account/deleted")({
  head: () => ({ meta: [{ title: "Account deleted · Pax.co" }] }),
  validateSearch: (search: Record<string, unknown>): { requested?: string; deleted?: string } => ({
    requested: optionalTime(search.requested),
    deleted: optionalTime(search.deleted),
  }),
  component: AccountDeletedRoute,
});

function AccountDeletedRoute() {
  const { requested, deleted } = Route.useSearch();
  return <AccountDeletedPage requested={requested} deleted={deleted} />;
}
